"use client";

import Image from "next/image";
import dynamic from "next/dynamic";
import RegInput from "../Input/RegInput";
import Info from "@/assets/icon/info.svg?url";
const Spinner = dynamic(() => import("@/components/common/Spinner"), {
  ssr: false,
});

const FindByReg = ({ t, register, isFetching, handleSubmit, findUsingReg }) => {
  return (
    <form noValidate onSubmit={handleSubmit(findUsingReg)}>
      {isFetching && (
        <div className="flex justify-center absolute w-full h-full top-0 z-[50] blur-backdrop">
          <Spinner />
        </div>
      )}
      <div className="selectValueBox flex">
        <div className="findByRegistrationBox">
          <div className="flex justify-between xs:flex-row flex-col">
            <RegInput t={t} register={register} />
            <button type="submit" className="green-btn">
              {t("button.find_parts")}
            </button>
          </div>
          <div className="flex-center mt-2 xs:mt-[14px]">
            <Image
              src={Info}
              alt="info"
              width={24}
              height={24}
              unoptimized
              className="me-1 xs:max-w-[24px] max-w-[15px] xs:top-0 -top-[1px] relative"
            />
            <p className="text-minor-text-1-mb xs:text-body-text-3-m lg:text-body-text-2-m text-primary-black">
              {t("current_vehicle.enterNumberPlate")}
            </p>
          </div>
        </div>
      </div>
    </form>
  );
};

export default FindByReg;
